import React from 'react'
import {FooterContainer, FooterText} from "./styles/styled.footer"

function handleWhatsAppClick() {
  window.open("https://www.cortadodigital.com", '_blank', 'noopener,noreferrer');
}

function Footer() {
  return (
    <FooterContainer  onClick={() => handleWhatsAppClick()}>
        <FooterText>Homecare Cleaning Products. All Rights Reserved. (2022)</FooterText>
        <FooterText>Website developed by Cortado Digital</FooterText>
    </FooterContainer>
  )
}

export default Footer